import { useUserHasHandoffLicense } from '@chilipiper/license'
import { useUserHasLiveChatLicense } from './useUserHasLiveChatLicense'
import { useUserHasConciergeLiveLicense } from './useUserHasConciergeLiveLicense'

export const useShouldShowOnlineToggle = () => {
  const userHasLiveChatLicense = useUserHasLiveChatLicense()
  const { isHandoffLiveEnabled } = useUserHasHandoffLicense()
  const hasConciergeLiveLicense = useUserHasConciergeLiveLicense()
  return userHasLiveChatLicense || isHandoffLiveEnabled || hasConciergeLiveLicense
}
